import { attributes, customAttributes } from './attributes';
import { findElementAll } from './find-element';
export function findAllDraggables(_ref) {
  var droppableId = _ref.droppableId,
    contextId = _ref.contextId;
  return findElementAll({
    attribute: attributes.draggable.contextId,
    value: contextId
  }, {
    attribute: customAttributes.draggable.droppableId,
    value: droppableId
  });
}